import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageService } from '../services/local-storage.service';

export const noAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);

  const token = localStorageService.getToken();

  if (token) {
    // If the user is already authenticated, redirect them to the dashboard or another route
    router.navigate(['/locker']); // Redirect authenticated users
    return false;
  }

  return true; 
};
